__turbopack_context__.v({
  "author": "BlogCard-module-scss-module__Ll3oGG__author",
  "bannerImage": "BlogCard-module-scss-module__Ll3oGG__bannerImage",
  "card": "BlogCard-module-scss-module__Ll3oGG__card",
  "cardImage": "BlogCard-module-scss-module__Ll3oGG__cardImage",
  "container": "BlogCard-module-scss-module__Ll3oGG__container",
  "content": "BlogCard-module-scss-module__Ll3oGG__content",
  "featured": "BlogCard-module-scss-module__Ll3oGG__featured",
  "featuredChip": "BlogCard-module-scss-module__Ll3oGG__featuredChip",
  "image": "BlogCard-module-scss-module__Ll3oGG__image",
  "imageWrapper": "BlogCard-module-scss-module__Ll3oGG__imageWrapper",
});
